import { render } from "./DocsInfoLink.vue?vue&type=template&id=1f5dc557"
import script from "./DocsInfoLink.vue?vue&type=script&lang=js"
export * from "./DocsInfoLink.vue?vue&type=script&lang=js"

import "./DocsInfoLink.vue?vue&type=style&index=0&id=1f5dc557&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__